import { mutations as authMutations, actions as authActions, state as authState, getters as authGetters } from './auth';
import cart from '@/store/cart.js';
import orderHistory from '@/store/orderHistory.js';

export const storeConfig = {
  state: {
    ...authState
  },
  getters: {
    ...authGetters
  },
  mutations: {
    ...authMutations
  },
  actions: {
    ...authActions
  },
  modules: {
    cart,
    orderHistory
  }
};
